import { useEffect, useState } from "react";
import type { BandwidthReport } from "@/diagnostics/networkBandwidth/types";
import { getNetworkBandwidthMonitor } from "@/diagnostics/networkBandwidth/networkBandwidthMonitor";

const POLL_MS = 500;

/** Poll the active bandwidth monitor for live report updates. */
export const useBandwidthReport = (active: boolean): BandwidthReport | null => {
  const [report, setReport] = useState<BandwidthReport | null>(null);

  useEffect(() => {
    if (!active) {
      return;
    }

    const poll = (): void => {
      const api = window.__benchmarkBandwidth;
      if (api) {
        setReport(api.getReport());
      }
    };

    poll();
    const id = window.setInterval(poll, POLL_MS);
    return () => window.clearInterval(id);
  }, [active]);

  return active ? report : null;
};

/** Start the monitor on mount and tear it down on unmount. */
export const useBandwidthMonitorSession = (enabled: boolean): boolean => {
  const [monitorActive, setMonitorActive] = useState(false);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const monitor = getNetworkBandwidthMonitor();
    monitor.start();
    queueMicrotask(() => setMonitorActive(true));

    return () => {
      monitor.stop();
      setMonitorActive(false);
    };
  }, [enabled]);

  return enabled && monitorActive;
};
